import React from 'react';
import { UserPlus, X } from 'lucide-react';
import PromoterForm from '../promoters/PromoterForm';

interface Props {
  respondentName: string;
  respondentEmail: string;
  onClose: () => void;
}

const AddPromoterFromSurveyModal: React.FC<Props> = ({ respondentName, respondentEmail, onClose }) => {
  const nameParts = respondentName.trim().split(' ');
  const firstName = nameParts[0] ?? '';
  const lastName = nameParts.slice(1).join(' ') ?? '';

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[2001] p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 flex-shrink-0">
          <div className="flex items-center gap-2">
            <UserPlus className="w-5 h-5 text-purple-600" />
            <h2 className="text-base font-semibold text-gray-900">Add as Promoter</h2>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg transition-colors">
            <X className="w-4 h-4 text-gray-500" />
          </button>
        </div>
        <div className="px-8 py-2 bg-purple-50 border-b border-purple-100 flex-shrink-0">
          <p className="text-sm text-purple-700">
            Pre-filled from survey response: <strong>{respondentEmail}</strong>
          </p>
        </div>
        <div className="overflow-y-auto flex-1 p-8">
          <PromoterForm
            onClose={onClose}
            initialValues={{
              first_name: firstName,
              last_name: lastName,
              email: respondentEmail,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AddPromoterFromSurveyModal;
